/**
 * A service that converts a payroll entry into a format that can be edited
 * in the manual submission editor.
 */
export class PayrollEntryManualSubmissionAdapter {
    constructor($q, payrollEntryService) {
        'ngInject';
        this.$q = $q;
        this.payrollEntryService = payrollEntryService;
    }

    /**
     * Get or create a manual request for a particular payroll entry.
     * @param {*} payrollEntry
     */
    createManualRequest(payrollEntry) {
        const manualRequest = {
            PayPeriodID: payrollEntry.PayPeriodID,
            ExtraTimeEntries: [],
            ExtraShowHours: [],
            PayrollEntryInput: {
                DataSyncEnabled: payrollEntry.DataSyncEnabled
            }
        };

        return payrollEntry.IsProcessedByAdp ? this.$q.resolve(manualRequest) :
            this.payrollEntryService.retrievePayrollEntryManualSubmission(payrollEntry.PayPeriodID);
    }
}

export function createPayPeriod(payrollID, payrollEntry) {
    return {
        PayrollID: payrollID,
        Employee: {
            EmployeeID: payrollEntry.EmployeeId,
            FirstName: payrollEntry.EmployeeFirstName,
            LastName: payrollEntry.EmployeeLastName,
            departmentName: payrollEntry.CompensationProfile,
            IsRegistrationComplete: payrollEntry.IsRegistrationComplete
        },
        Locked: payrollEntry.Locked,
        ManualRequestSubmitted: !payrollEntry.IsProcessedByAdp,
        PayPeriodID: payrollEntry.PayPeriodID,
        WeekNumber: payrollEntry.WeekNumber
    };
}

/**
 * Return a clone of the payroll containing only payroll entries
 * related to the entry being requested for manual.
 * @param {*} payroll The full payroll
 * @param {*} payrollEntry The payroll entry being requested as manual
 */
export function getFilteredPayroll(payroll, payrollEntry) {
    const payrollEntries = getPayrollEntriesByDepartment(payroll, payrollEntry.CompensationProfile)
        .filter(p => p.EmployeeId === payrollEntry.EmployeeId);
    return {
        ...payroll,
        CanUpdate: false,
        Locked: true,
        StartDate: payroll.PayrollStartDate,
        EndDate: payroll.PayrollEndDate,
        PayrollEntries: payrollEntries
    };
}

/**
 * Get the list of payroll entries under a particular department.
 * @param {*} payrollDepartments The objects segregating payroll entries by department
 * @param {*} departmentName The department name to be matched
 */
export function getPayrollEntriesByDepartment(payrollDepartments, departmentName) {
    switch (departmentName) {
        case 'Dept100':
            return payrollDepartments.OwnerPayrollEntries;
        case 'Dept200':
            return payrollDepartments.OfficeAdminPayrollEntries;
        case 'Dept400':
            return payrollDepartments.SalesPayrollEntries;
        case 'Dept900':
            return payrollDepartments.ContractorPayrollEntries;
        default:
            return [];
    }
}
